import { render, staticRenderFns } from "./Mushroom.vue?vue&type=template&id=7988426d&"
import script from "./Mushroom.vue?vue&type=script&lang=js&"
export * from "./Mushroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports